import { inject, observer } from "mobx-react";
import React from "react";
import AppStore from "../../Store";

@inject("appStore")
@observer
export default class WalletPage extends React.Component<{
  appStore: AppStore;
  history: any;
  location: Location
}> {

  public static url: string = "/wallet-pay";

  componentDidMount() {
    // console.log(`AnswerId: ${this.props.appStore.answerId}`);
  }

  render() {
    return (
      <div id="wallet">
      </div>
    );
  }
}
